"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.fetchByStation = exports.fetchByGps = void 0;

var pipeable_1 = require("fp-ts/lib/pipeable");

var TE = __importStar(require("fp-ts/lib/TaskEither"));

var util_1 = require("../../util");

var validation_1 = require("./validation");
/**
 * Check if the response we get from aqicn is `{"status": "error", "msg": "..."}`,
 * if yes, return an error.
 */


function checkError(_a) {
  var status = _a.status,
      data = _a.data,
      msg = _a.msg;
  return status === 'ok' ? TE.right(data) : TE.left(new Error(msg || data));
}
/**
 * Check that a token has been correctly passed
 *
 * @param options - Options to pass to aqicn
 */


function checkToken(options) {
  if (!options || !options.token) {
    return TE.left(new Error('AqiCN requires a token'));
  }

  return TE.right(undefined);
}
/**
 * Fetch the closest station to the user's current position
 *
 * @param gps - Latitude and longitude of the user's current position
 */


function fetchByGps(gps, options) {
  var latitude = gps.latitude,
      longitude = gps.longitude;
  return pipeable_1.pipe(checkToken(options), TE.chain(function () {
    return util_1.fetchAndDecode("https://api.waqi.info/feed/geo:" + latitude + ";" + longitude + "/?token=" + options.token, validation_1.ByStationCodec);
  }), TE.chain(checkError));
}

exports.fetchByGps = fetchByGps;
/**
 * Fetch data by station
 *
 * @param stationId - The station ID to search
 */

function fetchByStation(stationId, options) {
  return pipeable_1.pipe(checkToken(options), TE.chain(function () {
    return util_1.fetchAndDecode("https://api.waqi.info/feed/@" + stationId + "/?token=" + options.token, validation_1.ByStationCodec);
  }), TE.chain(checkError));
}

exports.fetchByStation = fetchByStation;